import Scriba from 'react-scriba';

export class DataContact {

    static _chargementContact = (idContact) => {
        const objet = { idContact };
        const url = "api/Fiche/FicheContact";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementPickerContact(idContact) {
        let objet = {
            "idContact": idContact
        }

        var url = "api/Get/GetPickerContact";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
    static _onEnregistrementContact(contact, enfants, idOperation, idLotCommercial, idReservation, idNature) {
        let objet = {
            "contact": contact,
            "enfants": enfants,
            "idOperation": idOperation,
            "idLotCommercial": idLotCommercial,
            "idReservation": idReservation,
            "idNature": idNature
        }

        var url = "api/MAJDonnees/EnregistrementContact";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementLiaisonEntreSouhaitEtReservation(idReservation, idOperation, idContact, idSouhait) {
        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation,
            "idContact": idContact,
            "idSouhait": idSouhait
        }

        var url = "api/MAJDonnees/EnregistrementLiaisonEntreSouhaitEtReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementTransfertProprieteContact(listeIdContacts, listeCommercialisateurs, loginCompteCible) {
        const objet = { listeIdContacts, listeCommercialisateurs, loginCompteCible }
        const url = "api/MAJDonnees/EnregistrementTransfertProprieteContact";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    // KP - 2023/03/21 - 2332 : mise à jour isolée car doit pouvoir s'exécuter même si formulaire invalide
    static _onEnregistrementVisualerLeContact = (idContact) => {
        const objet = { idContact };
        const url = "api/MAJDonnees/EnregistrementVisualerLeContact";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementListeDesDroitsFicheContact = () => {
        const url = "api/Droit/ListeDesDroitsFicheContact";
        const paramPost = Scriba.fetch().createParameterPost();
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionContact(idContact) {
        let objet = {
            "idContact": idContact
        }

        var url = "api/MAJDonnees/SuppressionContact";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onGetSiContactExiste(contact) {

        var url = "api/Get/GetSiContactExiste";
        var paramPost = Scriba.fetch().createParameterPost(contact);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheContactHistorique(idContact) {
        let objet = {
            "idContact": idContact
        }

        var url = "api/Fiche/FicheContactHistorique";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementListeDesCONTACTS = (nbreEnreg, recherche, tri, pageIndex, filtreIdSociete, filtreLoginCompte, filtreNomContact, filtreLoginProprietaire, filtreLoginCreateur, filtreDateCreation, filtreDateModification) => {
        const objet = { nbreEnreg, recherche, tri, pageIndex, filtreIdSociete, filtreLoginCompte, filtreNomContact, filtreLoginProprietaire, filtreLoginCreateur, filtreDateCreation, filtreDateModification };
        const url = "api/Liste/ListeDesCONTACTS";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onRegardeSiExisteDenonciationPourUnAutreCommercialisateurEtPourMoi(idContactSelectionne, idOperation) {
        const objet = {
            "idContact": idContactSelectionne,
            "idOperation": idOperation,
        };
        const url = "api/Get/RegardeSiExisteDenonciationPourUnAutreCommercialisateurEtPourMoi";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _envoyerIdentifiantsAContactParMail = (idContact) => {
        const objet = { "idContact": idContact };
        const url = "api/Email/EnvoyerIdentifiantsAContactParMail";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };

    static _miseAJourStatutCapsules(idsContactsChiffres, idStatut) {
        const objet = { idsContactsChiffres, idStatut };
        const url = "api/MAJDonnees/MiseAJourStatutCapsules";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _envoyerMailReservation = (idsContactsChiffres) => {
        const objet = { idsContactsChiffres };
        const url = "api/Email/EnvoyerMailReservation";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };

    static _visualiserCapsule = (idContactChiffre, version) => {
        const objet = { idContactChiffre, version };
        const url = "api/Get/VisualiserCapsule";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onRechargementContactDeLaReservation(idOperation, idReservation) {
        let objet = {
            "idOperation": idOperation,
            "idReservation": idReservation
        };

        var url = "api/Get/GetContactDeLaReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _getContactRecherche = (nom) => {
        const objet = { nom };
        const url = "api/Get/GetContactRecherche";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

}